module.exports = __webpack_public_path__ + "img/logo-white.34de909b.png";